module.exports = __webpack_public_path__ + "static/media/silkycloud-black-5.4d3b5228.png";